import { hobbies, religionAndCommunityList } from "../data";
import { countryAndcities } from "../cities";
import { countries } from "../states";

const dobToAge = (dob) => {
    let today = new Date();
    let todayYear = today.getFullYear();
    let todayMonth = today.getMonth();
    let todayDate = today.getDate();
    let dobYear = parseInt(dob.split('/')[2]);
    let dobMonth = parseInt(dob.split('/')[1]);
    let dobDate = parseInt(dob.split('/')[0]);
    let age = todayYear - dobYear;
    if (todayMonth < dobMonth - 1) {
        age--;
    }
    // eslint-disable-next-line
    if (dobMonth - 1 == todayMonth && todayDate < dobDate) {
        age--;
    }
    return age;
}


const compareUsers = (array1, array2) => {
    let result = false;
    array1?.forEach((element1) => {
        array2?.forEach((element2) => {
            if (element1.userId === element2.userId) {
                result = true;
            }
        })
    })
    return result;
}
const compareUser = (user1, array2) => {
    let result = false;
    array2?.forEach((element2) => {
        if (user1 === element2.userId) {
            result = true;
        }
    })
    return result;
}

//function to calculate sun sign from date of birth
const sunSign = (dob) => {
    let dobDate = dob.split('/')[0];
    let dobMonth = dob.split('/')[1];
    let sunSign = '';
    if (dobMonth === '1') {
        if (dobDate < 20) { sunSign = 'Capricorn'; }
        else { sunSign = 'Aquarius'; }
    }
    else if (dobMonth === '2') {
        if (dobDate < 19) { sunSign = 'Aquarius'; }
        else { sunSign = 'Pisces'; }
    }
    else if (dobMonth === '3') {
        if (dobDate < 21) { sunSign = 'Pisces'; }
        else { sunSign = 'Aries'; }
    }
    else if (dobMonth === '4') {
        if (dobDate < 20) { sunSign = 'Aries'; }
        else { sunSign = 'Taurus'; }
    }
    else if (dobMonth === '5') {
        if (dobDate < 21) { sunSign = 'Taurus'; }
        else { sunSign = 'Gemini'; }
    }
    else if (dobMonth === '6') {
        if (dobDate < 21) { sunSign = 'Gemini'; }
        else { sunSign = 'Cancer'; }
    }
    else if (dobMonth === '7') {
        if (dobDate < 23) { sunSign = 'Cancer'; }
        else { sunSign = 'Leo'; }
    }
    else if (dobMonth === '8') {
        if (dobDate < 23) { sunSign = 'Leo'; }
        else { sunSign = 'Virgo'; }
    }
    else if (dobMonth === '9') {
        if (dobDate < 23) { sunSign = 'Virgo'; }
        else { sunSign = 'Libra'; }
    }
    else if (dobMonth === '10') {
        if (dobDate < 23) { sunSign = 'Libra'; }
        else { sunSign = 'Scorpio'; }
    }
    else if (dobMonth === '11') {
        if (dobDate < 22) { sunSign = 'Scorpio'; }
        else { sunSign = 'Sagittarius'; }
    }
    else if (dobMonth === '12') {
        if (dobDate < 22) { sunSign = 'Sagittarius'; }
        else { sunSign = 'Capricorn'; }
    }
    return sunSign;
}

const hobbiesWithIcons = (hob) => {
    const hobbyMap = createHobbyMap();
    let hobbieIcons = [];

    for (let i = 0; i < hob?.length; i++) {
        if (hobbyMap.has(hob[i])) {
            const hobby = hobbyMap.get(hob[i]);
            hobbieIcons.push(hobby);
        }
    }

    return hobbieIcons;
};

const createHobbyMap = () => {
    const hobbyMap = new Map();

    for (let j = 0; j < 40; j++) {
        hobbyMap.set(hobbies[j].value, hobbies[j]);
    }

    return hobbyMap;
};

const findCommunities = (religion) => {
    let communities = [];
    for (let i = 0; i < 9; i++) {
        if (religionAndCommunityList[i].religion === religion) {
            communities = religionAndCommunityList[i].castes;
            break;
        }
    }
    return communities;
}

const extractCastes = () => {
    const allCastes = [];

    for (const entry of religionAndCommunityList) {
        allCastes.push(...entry.castes);
    }

    return allCastes;
}
const extractCities = () => {
    const allCastes = [];

    for (const entry of countryAndcities) {
        allCastes.push(...entry.cities);
    }

    return allCastes;
}

const extractStates = () => {
    const allStates = [];

    for (const entry of countries) {
        allStates.push(...entry.states);
    }

    return allStates;
}
export { dobToAge, sunSign, hobbiesWithIcons, findCommunities, extractCastes,extractStates, extractCities, compareUsers, compareUser }